import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UnitOfMeasureSettings } from 'src/app/settings/models/setting.model';
import { Environment } from 'src/environment';

import {
  GetObservationsResponse,
  ObservationsRegistration,
  UpsertObservationResponse,
} from '../models/within-cycle-performance.model';

@Injectable({
  providedIn: 'root',
})
export class ObservationService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/flock-registration/secure/observation`;

  serviceWorkerRegistration: ServiceWorkerRegistration;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  upsertObservation(
    observation: ObservationsRegistration,
    unitOfMeasureSettings: UnitOfMeasureSettings,
  ): Observable<UpsertObservationResponse> {
    const unitOfMeasureSettingsParam = { ...unitOfMeasureSettings };
    const unitOfMeasureSettingsQueryString = new URLSearchParams(
      unitOfMeasureSettingsParam,
    ).toString();

    return this.http
      .post<UpsertObservationResponse>(
        // eslint-disable-next-line max-len
        `${this.baseUrl}/cycle/${observation.cycleId}/barn/${observation.barnId}/intervalType/${observation.intervalType}/intervalValue/${observation.intervalValue}?${unitOfMeasureSettingsQueryString}`,
        observation,
        {
          headers: {
            OfflineIdentifier: 'UpsertObservation',
            OfflineResponse: '{"id": 0, "offline": true}',
          },
        },
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 304) {
            return of({
              isOffline: true,
              id: 0,
            } as UpsertObservationResponse);
          }
          return throwError(error);
        }),
      );
  }

  getObservations(
    cycleId: number,
    unitOfMeasureSettings: UnitOfMeasureSettings,
  ): Observable<ObservationsRegistration[]> {
    const unitOfMeasureSettingsParam = { ...unitOfMeasureSettings };
    const unitOfMeasureSettingsQueryString = new URLSearchParams(
      unitOfMeasureSettingsParam,
    ).toString();

    return this.http
      .get<GetObservationsResponse>(
        `${this.baseUrl}/${cycleId}?${unitOfMeasureSettingsQueryString}`,
      )
      .pipe(
        map((response: GetObservationsResponse) => response.observations),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<ObservationsRegistration[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
